<template>
    <div>
        <table class="table table-striped table-fixed" id="main-table">
            <thead>
            <tr>
                <th class="th-first">
                    <input type="checkbox" id="check-all" style="position: relative; z-index: 1;">
                </th>
                <th v-for="column in columnsSelected" class="text-truncate text-wrap" @click="sortTable(column)" style="cursor: pointer;">
                    {{ getTrans(column) }}
                </th>
                <th class="th-last"></th>
            </tr>
            </thead>
            <tbody>
            <tr class="row-click row-show" v-for="document in sortedDocuments">
                <td class="td-padding wrap-text-inside-td">
                    <input type="checkbox" id="" style="position: relative; z-index: 1;">
                </td>
                <td v-for="column in columnsSelected" class="td-padding wrap-text-inside-td">
                    {{ getValue(column, document) }}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            documents: [], // Twoje dane
            columnsSelected: [], // Wybrane kolumny
            sortColumn: null, // Kolumna, według której sortujemy
            sortDirection: 'asc', // Kierunek sortowania (asc lub desc)
        };
    },
    computed: {
        sortedDocuments() {
            if (!this.sortColumn) {
                return this.documents;
            }
            return this.documents.slice().sort((a, b) => {
                const valueA = this.getValue(this.sortColumn, a);
                const valueB = this.getValue(this.sortColumn, b);
                if (this.sortDirection === 'asc') {
                    return valueA.localeCompare(valueB);
                } else {
                    return valueB.localeCompare(valueA);
                }
            });
        },
    },
    methods: {
        sortTable(column) {
            if (this.sortColumn === column) {
                // Jeśli kliknięto na aktualną kolumnę, zmień kierunek sortowania
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                // Jeśli kliknięto na inną kolumnę, zresetuj kierunek sortowania
                this.sortColumn = column;
                this.sortDirection = 'asc';
            }
        },
    },
};
</script>
